import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "unit-container",
  id: "unit-container-pre"
}
const _hoisted_2 = {
  key: 1,
  class: "unit-container",
  id: "unit-container-post"
}
const _hoisted_3 = { class: "count-to__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["count-to__container", `counter-style--${_ctx.counterStyle} ${_ctx.large && 'large'}`]),
    style: _normalizeStyle({'--counter__width': `${_ctx.width * (_ctx.large ? 1.618 : 1)}px`, '--counter__height': `${_ctx.height * (_ctx.large ? 1.618 : 1)}px`})
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: "count-to__counter",
      ref: "element",
      style: _normalizeStyle({ '--counter__color': _ctx.counterStyle !== 'default' ? '--directr__white' : _ctx.color  })
    }, [
      _renderSlot(_ctx.$slots, "svg", {
        id: "count_container",
        start: _ctx.start,
        count: _ctx.value && typeof _ctx.value === 'object' ? _ctx.value.value : _ctx.value
      }, () => [
        (_ctx.prependUnit && _ctx.unit)
          ? (_openBlock(), _createElementBlock("text", _hoisted_1, _toDisplayString(_ctx.unit || ''), 1))
          : _createCommentVNode("", true),
        _createElementVNode("text", {
          style: _normalizeStyle({transform: _ctx.prependUnit && _ctx.unit ? 'translate(15px, 0px)' : ''}),
          id: "count_container"
        }, null, 4),
        (!_ctx.prependUnit && _ctx.unit)
          ? (_openBlock(), _createElementBlock("text", _hoisted_2, _toDisplayString(_ctx.unit || ''), 1))
          : _createCommentVNode("", true)
      ])
    ], 4)),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "label", { label: _ctx.label }, () => [
        _createElementVNode("span", null, _toDisplayString(_ctx.label), 1)
      ])
    ]),
    _renderSlot(_ctx.$slots, "append", { label: _ctx.label })
  ], 6))
}